"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlagListApi = FlagListApi;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const FlagList_1 = require("../FlagList/FlagList");
function FlagListApi({ flagApiUrl, setFlagValue, overrides }) {
    const [error, setError] = (0, react_1.useState)(null);
    const [isLoaded, setIsLoaded] = (0, react_1.useState)(false);
    const [flags, setFlags] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        fetch(flagApiUrl)
            .then(res => res.json())
            .then((result) => {
            setIsLoaded(true);
            setFlags(result);
        }, (error) => {
            setIsLoaded(true);
            setError(error);
        });
    }, [flagApiUrl]);
    if (error) {
        console.error(error);
        return (0, jsx_runtime_1.jsx)("div", { children: "Doh! Something went wrong." });
    }
    if (!isLoaded) {
        return (0, jsx_runtime_1.jsx)("div", { children: "Loading..." });
    }
    return (0, jsx_runtime_1.jsx)(FlagList_1.FlagList, { flags: flags, setFlagValue: setFlagValue, overrides: overrides });
}
FlagList_1.FlagList.propTypes = {
    /** The url used to both get feature flag data and force into tests */
    flagApiUrl: prop_types_1.default.string,
    /** a function to set the new override for a flag */
    setFlagValue: prop_types_1.default.func.isRequired,
    /** overrides that have been selected in the widget  */
    overrides: prop_types_1.default.objectOf(prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string, prop_types_1.default.bool])).isRequired
};
//# sourceMappingURL=FlatListApi.js.map